import SoundSource from './SoundSource';
import { addSuspendEvents } from './detectWebOsSuspendedApp';
import { registerAudioContext } from './canBrowserPlayAudio';

export default function initializeSoundSource(sounds = []) {
	window.AudioContext = window.AudioContext || window.webkitAudioContext;
	const context = new AudioContext();
	
	// Register this context for monitoring and resuming by AudioStatusIndicator
	registerAudioContext(context);
	
	const source = new SoundSource(context, sounds, () => {
		log('SoundSource loaded');
	});
	addSuspendEvents(source);
	return source;
}
